import { useTranslation } from "react-i18next";
import "./index.scss";

const email = "info@watugot.net";

export const FooterSection = () => {
  const { t } = useTranslation();
  return (
    <div className="c-footer-section">
      hehe
      <div className="c-footer-section__content">
        <a
          href={`mailto:${email}`}
          onClick={() => {
            navigator.clipboard.writeText(email);
          }}
        >
          {t("presentationPage.contact")}
        </a>
        <a
          href="/Watugot-Terms_and_Conditions.docx"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("presentationPage.legal")}
        </a>
        <a
          href="/Watugot-Privacy_Policy.docx"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("presentationPage.privacy")}
        </a>
        <a
          href="https://x.com/watugotofficial?s=21&t=JZgDGdI48nxLM_SgZi8Y9Q"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("presentationPage.social")}
        </a>
      </div>
    </div>
  );
};
